<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">会员管理>会员设置</div>
		<el-row :gutter="24">
			<el-col :span="9">
				<span>
					<el-button type="primary" @click="$router.push('/product_set')">新建联名卡</el-button>
				</span>
				<div class="demotops" v-for="item in member" :key="item.id">
					<div class="demo1_card">
						<img :src="item.image" />
					</div>
					<el-container>
						<el-header>
							<div class="demo1_botton" v-if="item.id">
								<el-button type="text"
									@click="$router.push({path:'/product_set', query:{id: item.id}})">编辑</el-button>
								<el-button type="text" v-if="item.enable"
									@click="updateEnable(item.id, 0)">停用</el-button>
								<!-- <el-button type="text" style="color: red" v-if="!item.enable" @click="updateEnable(item.id, 1)">启用</el-button> -->
							</div>
						</el-header>
						<el-footer>
							<div class="demo1_price">
								<div>{{ item.title }}</div>
								<div>
									价格: {{ (item.price / 100).toFixed(2) }}元 /
									{{ item.valid==12 ?'年' :item.valid==6 ?'半年' :'三个月' }}
								</div>
							</div>
						</el-footer>
					</el-container>
				</div>
			</el-col>
			<el-col :span="15">
				<el-tabs v-model="activeName" type="card">
					<el-tab-pane label="会员" name="first">
						<pageone></pageone>
					</el-tab-pane>
					<el-tab-pane label="数据分析" name="second"></el-tab-pane>
					<el-tab-pane label="分享设置" name="third"></el-tab-pane>
				</el-tabs>
				<pagetwo v-if="activeName=='second'"></pagetwo>
				<pagethree v-if="activeName=='third'"></pagethree>
			</el-col>
		</el-row>
	</div>
</template>
<script>
	import pageone from "./product_user/product_user1.vue"
	import pagetwo from "./product_user/product_user2.vue"
	import pagethree from "./product_user/product_user3.vue"
	export default {
		components: {
			pageone,
			pagethree,
			pagetwo
		},
		data() {
			return {
				checkedlist: [],
				activeName: "first",
				member: [],
			};
		},
		methods: {
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) => (i === id ? (v.isActive = true) : (v.isActive = false)));
			},
			getMember() {
				this.$http.get("member/listMember").then(res => {
					this.member = res.body.data;
				})
			},
			updateEnable(id, type) {
				let uri = {
					id: id,
					type: type,
				};
				this.$http.post("member/type", JSON.stringify(uri)).then(res => {
					if (res.body.code != 200) {
						this.$message.error(res.body.msg);
					} else {
						this.getMember();
					}
				})
			}
		},
		mounted() {
			this.getMember();
		}
	};
</script>
<style lang="less" scoped>
	/deep/ .yxlabel {
		width: 20px;
		overflow: hidden;
	}

	.demotops {
		margin-top: 20px;
		width: 100%;
		height: 230px;
		background: #ECECEC;
		display: flex;
		padding: 20px 0px 20px 20px;
		box-sizing: border-box;

		.demo1_card {
			width: 313px;
			height: 190px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.demo1_price {
			box-sizing: border-box;
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #444343;
			flex: 1;

			>div {
				&:nth-child(2) {
					margin-top: 15px;
				}
			}
		}

		.demo1_botton {
			margin-left: 80px;
		}
	}

	//输入框列表
	.input_list {
		.input_one {
			display: flex;

			&:nth-child(n + 2) {
				margin-top: 20px;
			}

			.input_one_wen {
				padding-left: 10px;
				line-height: 30px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #3e3e3e;
				width: 100px;
			}
		}
	}

	// 页码器
	.pagescg {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	// 表格
	.usertable {
		width: 100%;
		margin-top: 20px;

		.table_title {
			margin-bottom: 8px;
			font-size: 15px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #c9c9c9;
			width: 100%;
			text-align: right;
		}
	}

	.tablie_select {
		margin-top: 10px;
		display: flex;

		div {
			line-height: 30px;
		}
	}
</style>